import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {APIService} from "../../services/api.service";
import {NotificationService} from "../../services/notification.service";
import {AuthenticationService} from "../../services/authentication.service";
import {isNgDiff, sleep} from "../../utils/angular";
import * as uuid from "uuid";
import {CreateProjectlistTask} from "../../interfaces/task";
import {showAPIError} from "../../utils/api";
import {environment} from "../../../environments/environment";
import {Projectlist} from "../../interfaces/projectlist";
import {ObjectID} from "../../interfaces";

@Component({
  selector: 'pfm-download-projectlist-modal',
  templateUrl: './download-projectlist-modal.component.html',
  styleUrls: ['./download-projectlist-modal.component.scss']
})
export class DownloadProjectlistModalComponent {

  @Input() projectlist: Projectlist|null = null;
  @Output() projectlistChange: EventEmitter<Projectlist|null> = new EventEmitter<Projectlist|null>();

  blobid: ObjectID|null = null;

  state: 'LOADING'|'CREATING'|'ERROR'|'DOWNLOAD' = 'LOADING'

  internalAsyncID: string = '';

  constructor(private api: APIService,
              private notification: NotificationService,
              private auth: AuthenticationService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isNgDiff(changes, 'projectlist')) {
      if (this.projectlist !== null) {
        this.loadPDF().then(() => {})
      } else {
        this.clear();
      }
    }
  }

  clear() {
    this.state = 'LOADING';
    this.internalAsyncID = '';
  }

  async loadPDF() {
    if (this.projectlist === null) return;

    const iaid = uuid.v4();

    try {
      this.state = 'LOADING';
      this.internalAsyncID = iaid;

      const data = (await Promise.all([this.api.getProjectlistPDF(this.projectlist.id), sleep(850)]))[0];

      if (this.internalAsyncID != iaid) return; // modal closed

      if (data.exists) {
        this.blobid = data.blob!.id;
        this.state = 'DOWNLOAD';
        return;
      }

      const baseTask = await this.api.startCreateProjectlistTasks(this.projectlist.id);

      if (this.internalAsyncID != iaid) return; // modal closed

      this.state = 'CREATING';

      while (true) {

        const task = (await this.api.getTask(baseTask.id)) as CreateProjectlistTask;

        if (this.internalAsyncID != iaid) return; // modal closed

        if (task.status === 'RUNNING') {
          await sleep(100);
          if (this.internalAsyncID != iaid) return; // modal closed
          continue;
        }

        if (task.status === 'FINISHED') {
          this.blobid = task.result!.blobID;
          this.state = 'DOWNLOAD';
          return;
        }

        if (task.status === 'ABORTED') {
          this.state = 'ERROR';
          this.notification.error('Fehler', 'Task wurde abgebrochen');
          return;
        }

        if (task.status === 'FAILED') {
          this.state = 'ERROR';
          this.notification.error('Fehler', task.error);
          return;
        }

        task.status;

        this.state = 'ERROR';
        this.notification.error('Fehler', "Unbekannter API Rückgabewert");
        return;

      }

    } catch (err) {

      this.state = 'ERROR';
      showAPIError(this.notification, 'PDF konnten nicht geladen werden', err);
      return;

    }
  }

  onModalShowChanged(show: boolean) {
    if (!show) {
      this.projectlistChange.emit(this.projectlist = null);
    }
  }

  downloadURL() {
    return `${environment.apiBaseUrl}company/${this.auth.getSelfCompanyID() ?? 'ERR'}/blobs/${this.blobid ?? 'NULL'}/data?xx-bearer-token=@${this.auth.getToken()}`
  }
}
